module.exports = {"extras":{"modem":{"title":"Gigabit WiFi-6 MESH 1800Mbps Modem <span class='ori-value'>(valued at $170)</span>","priceLarge":"FREE","monthlyPrice":0,"upfrontPrice":0,"deliveryFee":20,"priceSmall":"(Shipping fee applicable)","leadCopy":"The Exetel ZTE modem is:","image":"/images/broadband-zte-modem.png","desc":"Easy set-up. Plug & play.","list":["Gigabit Ready","Supports VDSL","Mesh Ready","VOIP"],"additional":"*subject to modem payout fee"}}}


//////////////////
// WEBPACK FOOTER
// ./resources/data/small-business/nbn-extras.json
// module id = Pa3l
// module chunks = 0